export const convertBytesToMegabytes = (bytes: number): string =>
  Number(bytes / 1000000).toFixed(2);

export const validateFileSize = (fileList: FileList): boolean => {
  if (!fileList?.length) return true;

  const maxFileSizeBytes = 100000000;
  const file = fileList.item(0) as File;
  const isSizeValid = file.size <= maxFileSizeBytes;

  return isSizeValid;
};
